/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserVo
 */
export interface UserVo {
    /**
     * 用户id
     * @type {number}
     * @memberof UserVo
     */
    id?: number;
    /**
     * 登录账号
     * @type {string}
     * @memberof UserVo
     */
    account?: string;
    /**
     * 密码
     * @type {string}
     * @memberof UserVo
     */
    password?: string;
    /**
     * 用户姓名
     * @type {string}
     * @memberof UserVo
     */
    name?: string;
    /**
     * 电话号码
     * @type {string}
     * @memberof UserVo
     */
    mobileNo?: string;
    /**
     * 邮政编码
     * @type {string}
     * @memberof UserVo
     */
    postNo?: string;
    /**
     * 电子邮箱
     * @type {string}
     * @memberof UserVo
     */
    email?: string;
    /**
     * 级别id
     * @type {number}
     * @memberof UserVo
     */
    gradeId?: number;
    /**
     * 国家id
     * @type {number}
     * @memberof UserVo
     */
    nationId?: number;
    /**
     * 客户商业类型  1 企业 2 个人
     * @type {number}
     * @memberof UserVo
     */
    businessType?: number;
    /**
     * 专属客服id
     * @type {number}
     * @memberof UserVo
     */
    customerServiceId?: number;
}

/**
 * Check if a given object implements the UserVo interface.
 */
export function instanceOfUserVo(value: object): value is UserVo {
    return true;
}

export function UserVoFromJSON(json: any): UserVo {
    return UserVoFromJSONTyped(json, false);
}

export function UserVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'account': json['account'] == null ? undefined : json['account'],
        'password': json['password'] == null ? undefined : json['password'],
        'name': json['name'] == null ? undefined : json['name'],
        'mobileNo': json['mobileNo'] == null ? undefined : json['mobileNo'],
        'postNo': json['postNo'] == null ? undefined : json['postNo'],
        'email': json['email'] == null ? undefined : json['email'],
        'gradeId': json['gradeId'] == null ? undefined : json['gradeId'],
        'nationId': json['nationId'] == null ? undefined : json['nationId'],
        'businessType': json['businessType'] == null ? undefined : json['businessType'],
        'customerServiceId': json['customerServiceId'] == null ? undefined : json['customerServiceId'],
    };
}

export function UserVoToJSON(json: any): UserVo {
    return UserVoToJSONTyped(json, false);
}

export function UserVoToJSONTyped(value?: UserVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'account': value['account'],
        'password': value['password'],
        'name': value['name'],
        'mobileNo': value['mobileNo'],
        'postNo': value['postNo'],
        'email': value['email'],
        'gradeId': value['gradeId'],
        'nationId': value['nationId'],
        'businessType': value['businessType'],
        'customerServiceId': value['customerServiceId'],
    };
}

